import React from 'react';
import {withStyles} from '@material-ui/core/styles';

const clicked = (targetUrl) => {
  window.analytics.track('Clicked Social Icon', {targetUrl: targetUrl});
};

const rightClicked = (targetUrl) => {
  window.analytics.track('Clicked Social Icon', {targetUrl: targetUrl, type: 'Right Click'});
};


function SocialIcon(props) {
  const {link, classes, iconUrl} = props;

  return (
    <div>
      <a href={link} target={'_blank'} onClick={() => (clicked(link))} onContextMenu={() => (rightClicked(link))}>
        <img className={classes.icon} src={iconUrl}/>
      </a>
    </div>
  );
}

export default withStyles((theme) => ({
  icon: {
    display: 'block',
    width: 40,
    height: 40,
  }
}))(SocialIcon);


// WEBPACK FOOTER //
// ./src/parts/SocialIcon.js